import { render, staticRenderFns } from "./App.vue?vue&type=template&id=9163be2c&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=9163be2c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9163be2c",
  null
  
)

component.options.__file = "App.vue"
export default component.exports